import { computed, ComputedRef } from "vue"
import { useStore } from "@/store"
import { toPrefixedId } from "@/utils/prefixed-id"

/** The signed-in staff user's id as the patient-conversation API spells it (`usr_…`). */
export function useCurrentStaffId(): ComputedRef<string | undefined> {
  const store = useStore()
  return computed(() => {
    const userId: string | undefined = store.getters["me/userId"]
    return userId ? toPrefixedId("usr", userId) : undefined
  })
}
